export default function removeNonNumericChars(term: string): string {
    return term.replace(/[^0-9]/g, '');
}
